export enum SingleSlotDetailsDataHook {
  SERVICE_NAME = 'single-slot-details-service-name',
  PRICE_LINE = 'single-slot-details-price-line',
}
